import * as types from './types';

const addFilter = filter => ({ type: types.ADD_FILTER, payload: filter });
const removeFilter = filter => ({ type: types.REMOVE_FILTER, payload: filter });
const setFilter = filters => ({ type: types.SET_FILTERS, payload: filters });

const fetchLeads = (status, postingId) => ({ type: types.FETCH_COUNTER_LEAD, payload: { status, postingId } });
const fetchLeadsFailed = () => ({ type: types.FETCH_COUNTER_LEAD_FAILED });
const fetchLeadsSucceeded = total => ({ type: types.FETCH_COUNTER_LEAD_SUCCEEDED, payload: total });

export { addFilter, removeFilter, setFilter, fetchLeads, fetchLeadsFailed, fetchLeadsSucceeded };
